export default {
  'Resolution': 'Resolusi',
  'Frame rate': 'Frame rate',
  'The higher the frame rate, the smoother the animation': 'Semakin tinggi frame rate, semakin halus animasinya.',
}